import _ from 'lodash'

import { filtersRequiringDestinations } from '../../configuration/filtering'

export function convertDestinationFilterIdsToTitles(filters, destinations) {
  const convertedFilters = {}
  _.forEach(filters, (filterSet, filterKey) => {
    if (_.includes(filtersRequiringDestinations, filterKey)) {
      // convert destination ids to titles and filter undefined results
      const destinationTypeFilterSet = _.map(filterSet, destinationKey => destinations[destinationKey])
      convertedFilters[filterKey] = _.filter(destinationTypeFilterSet)
    } else {
      convertedFilters[filterKey] = filterSet
    }
  })
  return convertedFilters
}
